import { Link } from "react-router-dom";
import { COMPANY_CHILDREN, GROUP_COMPANIES, LOGO_URL } from "@/constants/site";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-100">
      <div className="mx-auto w-full max-w-7xl px-6 pt-16 pb-10 md:px-12 md:pt-20 lg:px-20">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <img src={LOGO_URL} alt="REVRA Group ロゴ" className="h-14 w-auto brightness-0" />
            <p className="mt-6 max-w-xs font-body text-sm leading-relaxed text-foreground-700">
              Revolution × Era。
              <br />
              ヒトの可能性を、価値に変える。
            </p>
            <p className="mt-5 font-label text-xs tracking-[0.28em] text-secondary-600">
              CHALLENGE THE NEXT ERA.
            </p>
          </div>

          <div>
            <h4 className="font-label text-sm tracking-[0.24em] text-foreground-950">
              <Link to="/company" className="transition-colors hover:text-accent-700">
                COMPANY
              </Link>
            </h4>
            <ul className="mt-5 flex flex-col gap-3">
              {COMPANY_CHILDREN.map((child) => (
                <li key={child.path}>
                  <Link
                    to={child.path}
                    className="font-body text-sm text-foreground-700 transition-colors hover:text-accent-700"
                  >
                    {child.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-sm tracking-[0.24em] text-foreground-950">GROUP</h4>
            <ul className="mt-5 flex flex-col gap-3">
              {GROUP_COMPANIES.map((company) => (
                <li key={company.name}>
                  {company.url ? (
                    <a
                      href={company.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-1.5 font-body text-sm text-foreground-700 transition-colors hover:text-accent-700"
                    >
                      {company.name}
                      <i className="ri-external-link-line text-xs" />
                    </a>
                  ) : (
                    <span className="font-body text-sm text-foreground-700">{company.name}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-sm tracking-[0.24em] text-foreground-950">MENU</h4>
            <ul className="mt-5 flex flex-col gap-3">
              <li>
                <Link
                  to="/recruit"
                  className="font-body text-sm text-foreground-700 transition-colors hover:text-accent-700"
                >
                  採用情報
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="font-body text-sm text-foreground-700 transition-colors hover:text-accent-700"
                >
                  お問い合わせ
                </Link>
              </li>
              <li>
                <Link
                  to="/company/philosophy"
                  className="font-body text-sm text-foreground-700 transition-colors hover:text-accent-700"
                >
                  経営理念
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-secondary-300/70 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-label text-xs tracking-[0.2em] text-secondary-700">
            © 2026 REVRA Group. All rights reserved.
          </p>
          <p className="font-body text-xs text-secondary-600">
            REVRA Group｜代表取締役 河出 享一郎
          </p>
        </div>
      </div>
    </footer>
  );
}